import { useId } from "react";

type LogoProps = {
  /** Applied to the root; set a text size (e.g. text-xl) to scale the whole lockup. */
  className?: string;
  /** Render only the square mark, no wordmark. */
  iconOnly?: boolean;
};

export default function Logo({ className = "", iconOnly = false }: LogoProps) {
  const gradientId = useId();

  return (
    <span
      className={`inline-flex select-none items-center gap-[0.45em] font-display leading-none ${className}`}
    >
      <svg
        viewBox="0 0 48 48"
        className="h-[1.9em] w-[1.9em] flex-none drop-shadow-sm"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={gradientId} x1="6" y1="4" x2="42" y2="45" gradientUnits="userSpaceOnUse">
            <stop stopColor="#2dd4bf" />
            <stop offset="1" stopColor="#0f766e" />
          </linearGradient>
        </defs>
        <rect width="48" height="48" rx="13" fill={`url(#${gradientId})`} />
        <path
          d="M15.5 9H28l7 7v21.5A2.5 2.5 0 0 1 32.5 40h-17a2.5 2.5 0 0 1-2.5-2.5v-26A2.5 2.5 0 0 1 15.5 9Z"
          fill="#fff"
        />
        <path d="M28 9l7 7h-5a2 2 0 0 1-2-2V9Z" fill="#99f6e4" />
        <path
          d="M18 21.5h12M18 26.5h12M18 31.5h6.5"
          stroke="#0f766e"
          strokeWidth="2.6"
          strokeLinecap="round"
        />
        <circle cx="32.5" cy="33.5" r="6.5" fill="#f59e0b" stroke="#fff" strokeWidth="2" />
        <path
          d="m29.8 33.6 1.9 1.9 3.4-3.7"
          fill="none"
          stroke="#fff"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {!iconOnly && (
        <span className="whitespace-nowrap text-[1.3em] font-bold tracking-tight">
          <span className="text-teal-600">Studio</span>
        </span>
      )}
    </span>
  );
}
